import HeroOverlay from './HeroOverlay';
import './HeroBackground.css';

// Full-bleed hero media with Home's shared dark overlays.
export default function HeroBackground({ imageUrl, imageAlt = '', children }) {
  return (
    <div className="site-hero-media">
      <div className="site-hero-media__mask">
        {children || <div
          data-hero-parallax="true"
          className="site-hero-media__image absolute inset-x-0 -top-40 -bottom-40 bg-cover"
          style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined}
          role={imageAlt ? 'img' : undefined}
          aria-label={imageAlt || undefined}
          aria-hidden={imageAlt ? undefined : true}
        />}
      </div>
      <HeroOverlay />
    </div>
  );
}
